module.exports = __webpack_public_path__ + "static/app-qr-code-5736641c23ee09589cc10c48628ccedf.png";